import { render, staticRenderFns } from "./DamageTableRow.vue?vue&type=template&id=1b0e82e9"
import script from "./DamageTableRow.vue?vue&type=script&lang=ts"
export * from "./DamageTableRow.vue?vue&type=script&lang=ts"
import style0 from "./DamageTableRow.vue?vue&type=style&index=0&id=1b0e82e9&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports